// extracted by mini-css-extract-plugin
export default {"main":"LeadSelector_main__fsb1s"};